import { severityClasses, type Severity } from '@/lib/severity'

/**
 * ANA.4 severity badge. 20px tall, 11/600 uppercase, tracking 0.06em.
 *
 * Wherever this renders, the ANA.4 legend must be reachable from the same page —
 * including the sentence "Severity is Bloom's classification."
 */
export function SeverityBadge({ severity }: { severity: Severity }) {
  return (
    <span
      data-severity-badge={severity}
      className={`inline-flex h-5 items-center rounded-sm px-1.5 text-overline ${severityClasses[severity]}`}
    >
      {severity}
    </span>
  )
}
